/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListEvents200ResponseLinks
 */
export interface ListEvents200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseLinks
     */
    last?: string;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListEvents200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the ListEvents200ResponseLinks interface.
 */
export function instanceOfListEvents200ResponseLinks(value: object): value is ListEvents200ResponseLinks {
    return true;
}

export function ListEvents200ResponseLinksFromJSON(json: any): ListEvents200ResponseLinks {
    return ListEvents200ResponseLinksFromJSONTyped(json, false);
}

export function ListEvents200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEvents200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function ListEvents200ResponseLinksToJSON(json: any): ListEvents200ResponseLinks {
    return ListEvents200ResponseLinksToJSONTyped(json, false);
}

export function ListEvents200ResponseLinksToJSONTyped(value?: ListEvents200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

